import { createI18nProxy } from '@/utils/i18nEnum';

export enum ModuleModeEnum {
    LECTURE = 1, // 선생님 혼자 수업 진행
    SELF = 2, // 학생 혼자 진행
}

const _moduleModeKeys: Record<ModuleModeEnum, string> = {
    [ModuleModeEnum.LECTURE]: 'enums.components.modules.common.buttons.lectugre',
    [ModuleModeEnum.SELF]: 'enums.components.modules.common.buttons.self',
};

export const moduleModeColor: Record<ModuleModeEnum, string> = {
    [ModuleModeEnum.LECTURE]: 'danger',
    [ModuleModeEnum.SELF]: 'primary',
};

/**
 * [moduleModeText]
 * 모듈 모드별 라벨을 제공하는 다국어 대응용 Proxy 객체입니다.
 *
 * [특징]
 * 1. 실시간 번역: moduleModeText[ModuleModeEnum.LECTURE]와 같이 접근하면 현재 언어 설정에 맞는 텍스트를 반환합니다.
 * 2. 하위 호환성: 기존의 정적 객체와 동일한 방식으로 사용 가능하여 기존 템플릿 코드를 수정할 필요가 없습니다.
 * 3. 안정성: Symbol.iterator 등 객체 내부 심볼 접근을 허용하여 Element Plus 등의 외부 라이브러리에서 순회(Iteration) 시 발생하는 오류를 방지합니다.
 */
export const moduleModeText = createI18nProxy(_moduleModeKeys);
